import { type ProOptions } from '@xyflow/react';
import { type ComponentType } from 'react';

import { STANDARD_EDGE_TYPES } from './Edges/constants.ts';
import { NodeCard } from './Nodes/Cards/BlockType/Card.tsx';
import { PlaceholderNodeCard } from './Nodes/Cards/BlockType/Placeholder.tsx';
import { GroupNodeCard } from './Nodes/Cards/Decorations/GroupNode/Card.tsx';
import { StickyNoteCard } from './Nodes/Cards/StickyNote/Card.tsx';
import { FlowNodeType } from './types';

const NODE_TYPES: Record<FlowNodeType, ComponentType<any>> = {
  [FlowNodeType.Block]: NodeCard,
  [FlowNodeType.Placeholder]: PlaceholderNodeCard,
  [FlowNodeType.StickyNote]: StickyNoteCard,
  [FlowNodeType.GroupNode]: GroupNodeCard,
};

const REACT_FLOW_PRO_OPTIONS: ProOptions = {
  account: 'paid-pro',
  hideAttribution: true,
} as const;

export const REACT_FLOW_GRAPH_PROPS = {
  nodeTypes: NODE_TYPES,
  edgeTypes: STANDARD_EDGE_TYPES,
  snapToGrid: true,
  snapGrid: [8, 8] as [number, number],
  minZoom: 0.2,
  maxZoom: 1.5,
  selectNodesOnDrag: false,
  proOptions: REACT_FLOW_PRO_OPTIONS,
  /**
   * The default value for panActivationKeyCode is 'Space' as seen in the xyflow repo.
   * This breaks accessibility, since it takes over the space key for all button activations.
   * Video example:
   * https://www.loom.com/share/a5869b1af2a74cfe9ba7ec8b07f77507?live_rewind=1
   *
   * https://github.com/xyflow/xyflow/blob/92f21356f7f34de3ad0c349cae1c1117f129c735/packages/react/src/container/ReactFlow/index.tsx#L72
   */
  panActivationKeyCode: '',
};
